export function hasShortMessage(
  errorOrResponse: unknown,
  target: string
): boolean {
  const errors = (errorOrResponse as any)?.errors;
  if (Array.isArray(errors)) {
    return errors.some((e) => e?.short_message === target);
  }
  return false;
}
